<template>
  <div class="resume-documents-group-files">
    <div class="resume-documents-group-files__list">
      <div v-for="(file, fileIndex) in filesFormat"
           :key="file.id"
           class="resume-documents-group-files__item">
<!--        <div @click.prevent="onDownload(file)"-->
<!--             class="resume-documents-group-files__item-download">-->
<!--          <BaseSvg name="ico-download-2"/>-->
<!--        </div>-->
        <FileShow :value="file"
                  @click.prevent="galleryIndex = fileIndex"
                  onlyShow
                  class="resume-documents-group-files__item-image"/>
        <div v-if="file.name"
             class="resume-documents-group-files__item-name">
          {{ file.name }}
        </div>
      </div>

      <CoolLightBox ref="lightBox"
                    v-if="files.length"
                    :items="files"
                    :index="galleryIndex"
                    @close="galleryIndex = null"/>
    </div>
  </div>
</template>

<script>
  import { isNil } from 'lodash';
  import download from '@/helpers/download'
  import FileShow from '@/components/FileShow'

  const CoolLightBox = () => import(/* webpackChunkName: "light-box" */ '../../components/CoolLightBox')

  let counter = 1

  export default {
    name: 'ResumeDocumentsGroupFiles',
    components: {
      FileShow,
      CoolLightBox
    },
    props: {
      files: Array
    },
    data() {
      return {
        galleryIndex: null
      }
    },
    computed: {
      filesFormat() {
        return this.files.map(file => {
          return {
            id: counter++,
            path: file,
            // name: file,
            ext: 'jpg'
          }
        })
      }
    },
    watch: {
      galleryIndex(value) {
        if (!isNil(value)) {
          setTimeout(() => this.$root.$el.appendChild(this.$refs.lightBox.$el));
        }
      },
    },
    methods: {
      onDownload(file) {
        download(file.path, file.name_for_download || file.name || file.path, null, true)
      },
    }
  }
</script>

<style lang="less">

</style>
